module.exports = __webpack_public_path__ + "static/media/uber_lyft_pricing_project.ebdd5cb8.pdf";